import(/* webpackMode: "eager" */ "/src/app/global-error.tsx")